// extracted by mini-css-extract-plugin
var _1 = "GroupBooking_booking__o35VR";
var _2 = "GroupBooking_breakable__A5yV6";
var _3 = "GroupBooking_clickable__+j54G";
var _4 = "GroupBooking_container__c9wOB";
var _5 = "GroupBooking_staticHeight__yOOy-";
export { _1 as "booking", _2 as "breakable", _3 as "clickable", _4 as "container", _5 as "staticHeight" }
